<div>
    <table>
        <tr>
            <th>{{ 'CARS.ITEM_HEADER' | translate }}</th>
            <th>{{ 'CARS.COST_HEADER' | translate }}</th>
            <th></th>
        </tr>
        <tr *ngFor="let item of listItems; let i = index">
            <td><span text-editable [(ngModel)]="item.name" class="name" (ngModelChange)="onItemChange()"></span></td>
            <td><span text-editable [(ngModel)]="item.value" class="value" [numericOnly]="true" (ngModelChange)="onItemChange()"></span></td>
            <td><span>₪</span></td>
            <td>
                <button mat-icon-button color="warn" (click)="removeRow(i)">
                    <fa-icon [icon]="faTimes"></fa-icon>
                </button>
            </td>
        </tr>
    </table>
    <button mat-fab color="primary" (click)="addRow()">
        <fa-icon [icon]="faPlus"></fa-icon>
    </button>
</div>
